import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllBlogs.css";

export default function ElectrificationOfLandscaping() {
  const location = useLocation();

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle =
      "Why Electric Lawn Care Benefits Strata Properties in Vancouver";
    document.title = newTitle;

    const newDescription =
      "Discover how electric lawn care equipment reduces noise, cuts emissions, and improves health for residential strata clients in Vancouver and beyond.";
    const descriptionMetaTag = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
      "electric lawn care Vancouver,electric landscaping equipment Vancouver,strata lawn maintenance Vancouver,quiet lawn mowing services Vancouver,eco-friendly lawn care Vancouver,zero-emission landscaping Vancouver,commercial electric mowers Vancouver,landscaping company North Vancouver, West Vancouver, Burnaby,strata property lawn care benefits, sustainable landscaping for strata councils",
    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector(
      'meta[property="og:description"]'
    );
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="beforeSection"></div>
      <div className="sectionBlogpost electrification">
        <a href="/blog" className="backPosts">
          <i className="bi bi-arrow-left"></i>
          Back
        </a>
        <article>
          <header>
            <h1>
              <div className="nth-line-1" data-aos="fade-up">
                Why Electrification of Landscaping
              </div>
              <div className="nth-line-2" data-aos="fade-up">
                Equipment Matters for Residential Strata Properties
              </div>
            </h1>
            <p className="lead" data-aos="fade-right"></p>
          </header>
          <hr />
          <section data-aos="fade-right">
            <p>
              When it comes to maintaining the landscapes of residential strata
              properties, many property managers and residents prioritize not
              only aesthetics but also the health and well-being of the
              community. One important—and often overlooked—factor is the type
              of equipment used to mow, trim, and maintain those landscapes.
              <br />
              At BUR-HAN Garden & Lawn Care, we've made a bold transition: our
              fleet of commercial lawn mowers, trimmers, and blowers is now
              fully electric. This move represents a significant advancement in
              quiet, eco-friendly, and health-conscious landscape maintenance.
              But why does this matter to residential strata clients?
            </p>
            <p>
              <span>The Noise Problem with Gas-Powered Equipment:</span>
              <br />
              Gas-powered landscaping equipment has long been the industry
              standard. Unfortunately, it comes with significant noise
              pollution. A typical gas-powered lawn mower or trimmer operates at
              95–105 decibels—similar to a chainsaw or a passing motorcycle.
              Even at 50 feet away, the noise can exceed 70 decibels, well above
              the World Health Organization's recommended daytime noise level of
              55 decibels for residential areas.
              <br />
              This isn't just an annoyance. The low-frequency noise produced by
              gas equipment travels farther and penetrates walls, meaning
              residents can hear the equipment up to 800 feet away, even inside
              their homes. Studies have linked chronic noise exposure to stress,
              hypertension, and cardiovascular disease.
              <br />
              By switching to electric equipment, we're dramatically reducing
              these impacts. In fact, our commercial mowers are 10 times
              quieter, our blowers are 3 times quieter, and our trimmers are
              between 10 and 100 times quieter than their gas equivalents,
              depending on speed. This translates to quieter mornings, peaceful
              afternoons, and healthier living environments for residents.
              <br />
            </p>
            <p>
              <span>Cleaner Air for Healthier Communities: </span>
              <br />
              Noise isn't the only problem with gas-powered equipment. These
              machines release harmful air pollutants, including:
              <br />
              - Volatile Organic Compounds (VOCs)
              <br />
              - Nitrogen Oxides (NOx)
              <br />
              - Carbon Monoxide (CO)
              <br />
              - Fine Particulate Matter (PM₂.₅)
              <br />
              Many gas-powered trimmers, blowers, and smaller mowers use
              2-stroke engines, which are highly polluting. These engines burn a
              mixture of gasoline and oil, releasing a large portion of unburned
              fuel and oil directly into the air. This creates high levels of
              fine particulate matter—tiny particles that can penetrate deep
              into the lungs and are linked to asthma, bronchitis, heart
              disease, and even lung cancer.
              <br />
              VOCs, meanwhile, are chemical compounds that evaporate into the
              air from fuel and exhaust. They react with sunlight to form
              ground-level ozone, a key component of smog. Exposure to VOCs can
              irritate the lungs, worsen asthma, increase the risk of
              respiratory infections, and even cause long-term organ damage.{" "}
              <br />
              By switching to electric equipment, we've eliminated these harmful
              emissions at the source. Residents can breathe easier knowing
              their outdoor spaces are being maintained without the exhaust of
              outdated, polluting machines.
            </p>
            <p>
              <span>An Investment in Sustainability and Compliance: </span>
              <br />
              Switching to electric equipment isn't just a choice for today—it's
              an investment in the future. As municipalities increasingly enact
              restrictions on gas-powered landscaping equipment due to noise and
              pollution concerns, properties maintained with electric equipment
              will already be ahead of compliance requirements. At BUR-HAN
              Garden & Lawn Care, we believe in aligning our services with the
              values of today's environmentally conscious communities. Electric
              equipment enhances your property's sustainability profile,
              contributing to greener, healthier, and more livable spaces for
              residents.
            </p>
            <p>
              <span>Experience the Benefits Firsthand: </span>
              <br />
              By partnering with a landscaping company that uses quiet,
              zero-emission electric equipment, strata councils and property
              managers can offer residents:
              <br />
              ✅ Quieter operations with significantly less noise intrusion
              <br />
              ✅ Cleaner air quality with no on-site emissions
              <br />
              ✅ Reduced health risks from both noise and air pollution
              <br />
              ✅ Future-proof compliance with emerging environmental regulations
              <br />
              We're proud to be leading the charge toward a cleaner, quieter
              future for Vancouver-area strata properties. If your community is
              ready to experience the benefits of electric landscaping, contact
              us today to learn more or request a quote.
            </p>
            <p>
              Want to experience the quiet, eco-friendly difference? Contact
              <a
                href="/contact-us"
                style={{ textDecoration: "none", color: "var(--yellow-color)" }}
              >
                {" "}
                BUR-HAN Garden and Lawn Care{" "}
              </a>
              today for a free consultation and discover how our fully electric
              equipment can benefit your residential strata property.
            </p>

            <p>
            At BUR-HAN Garden & Lawn Care, we proudly use electric landscaping equipment for a quieter and cleaner experience. <br/>
            <a
                href="/blog/bur-han-goes-all-electric!-here's-why-it-matters"
                style={{ textDecoration: "none", color: "var(--yellow-color)" }}
              >Click here to read more about our electric equipments.</a>

            </p>
          </section>
        </article>
        <div className="relatedArticles">
          <h3>Related Articles</h3>
          <ul>
            <li><a href="/blog/bur-han-goes-all-electric!-here's-why-it-matters">BUR-HAN Goes All-Electric! Here's Why It Matters</a></li>
            <li><a href="/blog/eco-friendly-lawn-care">Eco Friendly Lawn Care</a></li>
            <li><a href="/blog/weekly-lawn-cutting-service-in-vancouver-surrounding-areas">Weekly Lawn Cutting Service in Vancouver & Surrounding Areas</a></li>
          </ul>
        </div>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>
                  Fill out our contact page, and let our expert landscaping team
                  bring your vision to life with a personalized estimate
                  tailored to your unique preferences and needs.
                </p>
              </div>
              <div className="col-md-6 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
